import React, { useState } from 'react'
import { Avatar, Box, Drawer, Divider, List, ListItemButton, ListItemText, ListItemIcon, useMediaQuery, useTheme, Icon, Collapse, Menu, MenuItem } from '@mui/material';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import { useAppThemeContext, useDrawerContext, useAuthContext } from '../../contexts';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import logo from '../../../seduc.svg';
import logoInvertido from '../../../seduc_branco.svg';

import jwt_decode from "jwt-decode";
import { TJwtToken } from '../../services/api/usuario/auth/AuthService';
import { Api } from '../../services/api/axios-config';

interface IMenuLateralProps {
  children: React.ReactNode,
}

export const MenuLateral: React.FC<IMenuLateralProps> = ({ children }) => {
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));

  const navigate = useNavigate();
  const location = useLocation();

  const { toggleTheme, themeName } = useAppThemeContext();
  const { logout } = useAuthContext();

  const { isDrawerOpen, toggleDrawerOpen } = useDrawerContext();

  const aux = Api.defaults.headers.common['Authorization'];
  var token = "";
  if (typeof aux === "string") {
    token = aux.split(" ")[1];
  }
  var decoded: TJwtToken = jwt_decode(token);

  let agoraTimeStamp = new Date().getTime() / 1000;
  if (agoraTimeStamp > decoded.exp) {
    logout();
  }

  const visao = decoded.role;
  const indexar = decoded.Indexar;

  const [openUsuario, setOpenUsuario] = useState(false);
  const [openCliente, setOpenCliente] = useState(false);
  const [openDocumental, setOpenDocumental] = useState(false);
  const [openCaixa, setOpenCaixa] = useState(false);
  const [openDocumento, setOpenDocumento] = useState(false);
  const [openIndice, setOpenIndice] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickUsuario = () => {
    setOpenUsuario(!openUsuario);

    setOpenCliente(false);
    setOpenIndice(false);
    handleCloseAllDocumental();
  }
  const handleClickCliente = () => {
    setOpenCliente(!openCliente);

    setOpenUsuario(false);
    setOpenIndice(false);
    handleCloseAllDocumental();
  }
  const handleClickDocumental = () => {
    setOpenDocumental(!openDocumental);

    setOpenCliente(false);
    setOpenUsuario(false);
    setOpenIndice(false);

    if (openDocumental) {
      handleCloseAllDocumental();
    }
  }
  const handleClickCaixa = () => {
    setOpenCaixa(!openCaixa);

    setOpenDocumento(false);
    setOpenIndice(false);

  }
  const handleClickDocumento = () => {
    setOpenDocumento(!openDocumento);

    setOpenCaixa(false);
    setOpenIndice(false);
  }

  const handleClickIndice = () => {
    // console.log(openIndice);
    setOpenIndice(!openIndice);
    // console.log(!openIndice);

    setOpenCaixa(false);
    setOpenDocumento(false);
    // setOpenCliente(false);
    // setOpenUsuario(false);
    // handleCloseAllDocumental();
  }

  const handleCloseAllDocumental = () => {
    setOpenDocumental(false);
    setOpenCaixa(false);
    setOpenDocumento(false);
  }

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Drawer open={isDrawerOpen} variant={(mdDown || location.pathname === "/404") ? 'temporary' : 'permanent'} onClose={toggleDrawerOpen}>
        <Box width={theme.spacing(28)} height="100%" display="flex" flexDirection="column" overflow="auto">

          <Box width="100%" height={theme.spacing(16)} display="flex" alignItems="center" justifyContent="center">
            <img alt='Secretaria de Estado da Educação' src={themeName === 'light' ? logo : logoInvertido} onClick={() => navigate('/home')} />
          </Box>

          <Divider />

          <Box flex={1} overflow="auto">

            <List component="nav">

              <ListItemButton onClick={() => navigate('/home')}>
                <ListItemIcon>
                  <Icon>home</Icon>
                </ListItemIcon>
                <ListItemText primary="Página Inicial" />
              </ListItemButton>

              {visao !== "clienteFuncionario" && visao !== "zdocFuncionario" && (<>
                <ListItemButton onClick={handleClickCliente}>
                  <ListItemIcon>
                    <Icon>apartment</Icon>
                  </ListItemIcon>
                  <ListItemText primary={visao === "master" ? ("Gestão de Unidades") : ("Gestão da Unidade")} />
                  {/* <ListItemText primary={visao === "master" ? ("Gestão de clientes") : ("Gestão da empresa")} /> */}
                  {openCliente ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openCliente} timeout="auto" unmountOnExit>

                  <List component="div" disablePadding>

                    {visao === "master" && (<>
                      <ListItemButton sx={{ pl: 3 }} onClick={() => navigate('/cliente')}>
                        <ListItemIcon>
                          <Icon>apartmente</Icon>
                        </ListItemIcon>
                        {/* <ListItemText primary="Cliente" /> */}
                        <ListItemText primary="Unidade" />
                      </ListItemButton>
                    </>)}


                    <ListItemButton sx={{ pl: 3 }} onClick={() => navigate('/unidade')}>
                      <ListItemIcon>
                        <Icon>location_on</Icon>
                      </ListItemIcon>
                      <ListItemText primary="Área" />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 3 }} onClick={() => navigate('/setor')}>
                      <ListItemIcon>
                        <Icon>widgets</Icon>
                      </ListItemIcon>
                      <ListItemText primary="Setor" />
                    </ListItemButton>

                  </List>
                </Collapse>

                <ListItemButton onClick={handleClickUsuario}>
                  <ListItemIcon>
                    <Icon>people</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Gestão de Usuários" />
                  {openUsuario ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openUsuario} timeout="auto" unmountOnExit>

                  <List component="div" disablePadding>

                    <ListItemButton sx={{ pl: 3 }} onClick={() => navigate('/perfil')}>
                      <ListItemIcon>
                        <Icon>people</Icon>
                      </ListItemIcon>
                      <ListItemText primary="Perfil" />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 3 }} onClick={() => navigate('/usuario')}>
                      <ListItemIcon>
                        <Icon>person</Icon>
                      </ListItemIcon>
                      <ListItemText primary="Usuário" />
                    </ListItemButton>

                  </List>
                </Collapse>

              </>)}

              <ListItemButton onClick={handleClickDocumental}>
                <ListItemIcon>
                  <Icon>folder</Icon>
                </ListItemIcon>
                <ListItemText primary="Gestão Documental" />
                {openDocumental || openIndice ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openDocumental} timeout="auto" unmountOnExit>

                {visao !== "clienteFuncionario" && visao !== "zdocFuncionario" && (<>

                  <ListItemButton sx={{ pl: 3 }} onClick={handleClickIndice}>
                    <ListItemIcon>
                      <Icon>list</Icon>
                    </ListItemIcon>
                    <ListItemText primary="Índices" />
                    {/* <ListItemText primary="Gestão de índices" /> */}
                    {openIndice ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openIndice} timeout="auto" unmountOnExit>

                    <List component="div" disablePadding>

                      <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/indice')}>
                        <ListItemIcon>
                          <Icon>list</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Índice" />
                      </ListItemButton>

                      <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/tipo')}>
                        <ListItemIcon>
                          <LanOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Tipos" />
                      </ListItemButton>

                    </List>
                  </Collapse>
                </>)}
                <List component="div" disablePadding>

                  {(visao === "clienteGestor" || visao === "master" || indexar) &&
                    <>
                      <ListItemButton sx={{ pl: 3 }} onClick={handleClickCaixa}>
                        <ListItemIcon>
                          <Icon>inventory_2</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Caixas" />
                        {openCaixa ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>

                      <Collapse in={openCaixa} timeout="auto" unmountOnExit>

                        <List component="div" disablePadding>

                          <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/caixa/detalhe/nova')}>
                            <ListItemIcon>
                              <Icon>add</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Cadastrar" />
                          </ListItemButton>

                          <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/caixa')}>
                            <ListItemIcon>
                              <Icon>search</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Consultar" />
                          </ListItemButton>

                          {visao === "clienteGestor" || visao === "master" &&
                            <>
                              <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/gerarEtiqueta')}>
                                <ListItemIcon>
                                  <Icon>sell</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Etiqueta" />
                              </ListItemButton>

                              <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/codigoBarras')}>
                                <ListItemIcon>
                                  <Icon>view_week</Icon>
                                </ListItemIcon>
                                <ListItemText primary="Código de barras" />
                              </ListItemButton>
                            </>
                          }
                        </List>
                      </Collapse>

                    </>}

                  <ListItemButton sx={{ pl: 3 }} onClick={handleClickDocumento}>
                    <ListItemIcon>
                      <Icon>description</Icon>
                    </ListItemIcon>
                    <ListItemText primary="Documentos" />
                    {openDocumento ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openDocumento} timeout="auto" unmountOnExit>

                    <List component="div" disablePadding>

                      {(visao === "clienteGestor" || visao === "master" || indexar) &&
                        <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/documento/indexar/null/null/null')}>
                          <ListItemIcon>
                            <Icon>list</Icon>
                          </ListItemIcon>
                          <ListItemText primary="Indexar" />
                        </ListItemButton>
                      }

                      <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/documento')}>
                        <ListItemIcon>
                          <Icon>search</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Consultar" />
                      </ListItemButton>

                      {visao === "clienteGestor" || visao === "master" && (<>
                        <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/documento/certificar')}>
                          <ListItemIcon>
                            <Icon>done_all</Icon>
                          </ListItemIcon>
                          <ListItemText primary="Certificar" />
                        </ListItemButton>
                      </>)}

                    </List>
                  </Collapse>

                </List>

              </Collapse>

            </List>
          </Box>

          <Divider />

          <Box>
            <List component="nav">

              <ListItemButton
                onClick={handleClickMenu}
                id="menu"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
              >
                <ListItemIcon>
                  <Icon>settings</Icon>
                </ListItemIcon>
                <ListItemText primary="Configurações" />
              </ListItemButton>

              <Menu
                id="menu"
                aria-labelledby="button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >

                <MenuItem onClick={toggleTheme}>

                  <ListItemIcon>
                    <Icon>dark_mode</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Alternar Tema" />

                </MenuItem>

                <Divider />

                <MenuItem onClick={() => navigate('/editarDados')}>

                  <ListItemIcon>
                    <Icon>edit</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Editar Seus Dados" />

                </MenuItem>

                <MenuItem onClick={logout}>

                  <ListItemIcon>
                    <Icon>logout</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Sair" />

                </MenuItem>

              </Menu>

            </List>
          </Box>
        </Box>
      </Drawer>

      <Box height="100vh" marginLeft={(mdDown || location.pathname === "/404") ? 0 : theme.spacing(28)}>
        {children}
      </Box>
    </>
  );
}